import { render } from "./ViewSupportPage.vue?vue&type=template&id=6cc5fa06&ts=true"
import script from "./ViewSupportPage.vue?vue&type=script&lang=ts"
export * from "./ViewSupportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__